import { AxiosResponse } from 'axios';
import { addFavoriteTeam, loadTeams, removeFavoriteTeam } from '@/api/team';
import { TeamItem } from '@/models/team';
import { baseListService } from '@/services/baseService';
import { ITeamApiListResponse, ITeamFilters } from '@/types';
import { IListParams } from '@/types/service';
import { AppError } from '@/errors/appError';
import { useTeamStore } from '@/stores/team';
import { useAppStore } from '@/stores/app';

export const teamService = {
    async load(params: IListParams<ITeamFilters>): Promise<AxiosResponse<ITeamApiListResponse>> {
        const teamStore = useTeamStore();
        const appStore = useAppStore();

        appStore.loading = true;
        try {
            const response = await baseListService<ITeamApiListResponse>(loadTeams, params);
            teamStore.items = response.data.rows.map((item) => new TeamItem(item));
            teamStore.total = response.data.total;

            return response;
        } catch (e) {
            throw new AppError(`Unable load team list, request error`, { cause: e });
        } finally {
            appStore.loading = false;
        }
    },

    async addFavorite(ctId: number): Promise<AxiosResponse | void> {
        const teamStore = useTeamStore();

        if (teamStore.favoriteTeamProcessing[ctId]) {
            return;
        }

        teamStore.favoriteTeamProcessing[ctId] = true;
        try {
            const response = await addFavoriteTeam(ctId);
            teamStore.favoriteTeam[ctId] = 1;

            return response;
        } catch (e) {
            throw new AppError(`Unable to add favorite team #${ctId}, request error`, { cause: e });
        } finally {
            delete teamStore.favoriteTeamProcessing[ctId];
        }
    },

    async removeFavorite(ctId: number): Promise<AxiosResponse | void> {
        const teamStore = useTeamStore();

        if (teamStore.favoriteTeamProcessing[ctId]) {
            return;
        }

        teamStore.favoriteTeamProcessing[ctId] = true;
        try {
            const response = await removeFavoriteTeam(ctId);
            delete teamStore.favoriteTeam[ctId];

            return response;
        } catch (e) {
            throw new AppError(`Unable to delete favorite team #${ctId}, request error`, { cause: e });
        } finally {
            delete teamStore.favoriteTeamProcessing[ctId];
        }
    },
};
